import { Code, Palette, Gamepad2, Globe, Box, Shield, Sparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { ITDirection } from '@/types/test';

/**
 * Цветовые стили для иконки-плашки направления IT.
 * Вынесено из DirectionIcon.tsx, чтобы файл-компонент содержал только
 * компонент (требование react-refresh для HMR).
 *
 * Phase 3: добавлены стили для 12-14 направлений: WEB (тот же значок
 * Globe что у SITE — концептуально близко), SEC (Shield), AI (Sparkles).
 */
export interface DirectionStyle {
  Icon: LucideIcon;
  bgClass: string; // Tailwind utility, например 'bg-orange-100'
  fgClass: string; // например 'text-orange-500'
}

export const DIRECTION_STYLES: Record<ITDirection, DirectionStyle | null> = {
  PROG:   { Icon: Code,     bgClass: 'bg-blue-100',    fgClass: 'text-blue-600' },
  DESIGN: { Icon: Palette,  bgClass: 'bg-pink-100',    fgClass: 'text-pink-500' },
  GAME:   { Icon: Gamepad2, bgClass: 'bg-orange-100',  fgClass: 'text-orange-500' },
  SITE:   { Icon: Globe,    bgClass: 'bg-emerald-100', fgClass: 'text-emerald-600' },
  MODEL:  { Icon: Box,      bgClass: 'bg-violet-100',  fgClass: 'text-violet-500' },
  WEB:    { Icon: Globe,    bgClass: 'bg-cyan-100',    fgClass: 'text-cyan-600' },
  SEC:    { Icon: Shield,   bgClass: 'bg-red-100',     fgClass: 'text-red-600' },
  AI:     { Icon: Sparkles, bgClass: 'bg-amber-100',   fgClass: 'text-amber-600' },
  // DATA — резерв, в коде не используется (12-14 покрывает всё через AI).
  DATA: null,
};
